import { AlertTriangle } from "lucide-react";
import { fmtDate } from "@/lib/api";

export function daysUntil(iso) {
  if (!iso) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = new Date(iso); d.setHours(0, 0, 0, 0);
  if (isNaN(d)) return null;
  return Math.round((d - today) / 86400000);
}

export function ExpiryBadge({ date, testid, pastLabel = "Expired" }) {
  const days = daysUntil(date);
  if (days === null) return <span className="text-slate-400" data-testid={testid}>—</span>;
  const tone = days < 0
    ? "border-red-300 bg-red-50 text-red-700"
    : days <= 30 ? "border-amber-300 bg-amber-50 text-amber-800" : "border-emerald-200 bg-emerald-50 text-emerald-700";
  const label = days < 0 ? `${pastLabel} ${-days}d ago` : days === 0 ? "Today" : `${days}d left`;
  return (
    <span className="inline-flex flex-col leading-tight" data-testid={testid}>
      <span className="text-xs text-slate-700">{fmtDate(date)}</span>
      <span className={`mt-0.5 inline-flex items-center gap-1 self-start text-[10px] uppercase tracking-wider font-semibold border rounded-sm px-1.5 py-0.5 ${tone}`}>
        {days <= 30 && <AlertTriangle className="w-3 h-3" />}{label}
      </span>
    </span>
  );
}
